import React from "react";
import { navigate } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

const CountrySelector = ({ currentLanguage }) => {
  const Country = ({ lang }) => {
    switch (lang.split("_")[0]) {
      case "en":
        return (
          <>
            <StaticImage
              src={"../../../assets/images/menus/flags/singapore.svg"}
              alt={"singapore"}
              width={15}
              height={15}
            />
            <span className="mx-2">Singapore</span>
          </>
        );
      case "au":
        return (
          <>
            <StaticImage
              src={"../../../assets/images/menus/flags/australia.svg"}
              alt={"australia"}
              width={15}
              height={15}
            />
            <span className="mx-2">Australia</span>
          </>
        );
      case "id":
        return (
          <>
            <StaticImage
              src={"../../../assets/images/menus/flags/indonesia.svg"}
              alt={"indonesia"}
              width={15}
              height={15}
            />
            <span className="mx-2">Indonesia</span>
          </>
        );
      case "th":
        return (
          <>
            <StaticImage
              src={"../../../assets/images/menus/flags/thailand.svg"}
              alt={"thailand"}
              width={15}
              height={15}
            />
            <span className="mx-2">Thailand</span>
          </>
        );
      default:
        break;
    }
  };

  return (
    <div className="dropdown hover-to-show dropdown-country-selector mb-5 mt-md-5">
      <button
        className="button dropdown-toggle border d-flex align-items-center py-2 px-4"
        type="button"
        id="country-selector"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <Country lang={currentLanguage} />
      </button>
      <div className="dropdown-menu" aria-labelledby="country-selector">
        <button
          className="dropdown-item d-flex align-items-center"
          onClick={() => navigate("/au")}
        >
          <Country lang={"au"} />
        </button>
        <button
          className="dropdown-item d-flex align-items-center"
          onClick={() => navigate("/id")}
        >
          <Country lang={"id"} />
        </button>
        <button
          className="dropdown-item d-flex align-items-center"
          onClick={() => navigate("/th")}
        >
          <Country lang={"th"} />
        </button>
        <button
          className="dropdown-item d-flex align-items-center"
          onClick={() => navigate("/")}
        >
          <Country lang={"en"} />
        </button>
      </div>
    </div>
  );
};

export default CountrySelector;
